import { render } from "./ButtonRound.vue?vue&type=template&id=0a135f64"
import script from "./ButtonRound.vue?vue&type=script&lang=js"
export * from "./ButtonRound.vue?vue&type=script&lang=js"

import "./ButtonRound.vue?vue&type=style&index=0&id=0a135f64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__